import { getTokenFromLocalStorage } from '@/auth';
import Trend from '@/components//Trend';
import { toPercentageFormat } from '@/helpers';
import Services from '@/services';
import { Result } from '@/types/base';
import { BshCurrency } from '@/types/models';
import { useAuth0 } from '@auth0/auth0-react';
import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import styles from './index.less';

const CurrencyConverter: React.FC = () => {
    const { isAuthenticated } = useAuth0();
    const [currencies, setCurrencies] = useState<BshCurrency[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const token = getTokenFromLocalStorage();

    useEffect(() => {
        if (!isAuthenticated || !token) return;
        init();
    }, [isAuthenticated, token]);

    const init = async () => {
        try {
            setLoading(true);
            const response: Result<BshCurrency[]> = await Services.getCurrencies();
            if (!response.data) {
                setCurrencies([]);
                return;
            }
            const firstThree = response.data?.slice(0, 3) || [];
            const x = 0,
                y = 1;
            firstThree[x] = firstThree.splice(y, 1, firstThree[x])[0];
            setCurrencies(firstThree);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.currency_container}>
            {loading ? (
                <Spin spinning={loading} size="small"></Spin>
            ) : (
                currencies?.map((currency: BshCurrency, index: number) => {
                    return (
                        <div key={index} className={styles.item}>
                            <div style={{ width: 10 }}></div>
                            <img className={styles.flag} src={currency.flagUrl} alt="flag" />
                            <span className={styles.label}>{currency.currencyCode}</span>
                            <Trend flag={currency.changeInRate >= 0 ? 'up' : 'down'} reverseColor={true} />
                            <span className={styles.label}>{currency.currencyRate.toFixed(2)}</span>
                            <span className={styles.percentage} style={{ color: currency.changeInRate >= 0 ? '#52c41a' : '#f5222d' }}>
                                {toPercentageFormat(currency.changeInRate / currency.currencyRate)}
                            </span>
                        </div>
                    );
                })
            )}
        </div>
    );
};

export default CurrencyConverter;
